import React, { Fragment } from 'react'
import { shape, node, bool } from 'prop-types'
import classNames from 'classnames'

import ThemeConsumer from '../ThemeConsumer'


const BoxSimpleHeader = ({
  theme,
  children,
  verySimple,
}) => {
  const classes = classNames(
    { [theme.simple]: verySimple },
    { [theme.header]: !verySimple }
  )

  return (
    <Fragment>
      <header className={classes}>
        {children}
      </header>
      <hr />
    </Fragment>
  )
}
BoxSimpleHeader.propTypes = {
  children: node,
  theme: shape({
  }),
  verySimple: bool,
}

BoxSimpleHeader.defaultProps = {
  children: null,
  theme: {},
  verySimple: false,
}

export default ThemeConsumer('UIBox')(BoxSimpleHeader)



// WEBPACK FOOTER //
// ./src/shared/components/Box/BoxSimpleHeader.js